module.exports = __webpack_public_path__ + "static/img/hnsjb.5920d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/components/img/hnsjb.jpg
// module id = fZTw
// module chunks = 1